import { message } from "antd";

export const handleErrorWithToastMessage = (error: string | undefined) => {
  if (error) message.error(error);
};
